import { render } from "./terms-of-use.vue?vue&type=template&id=68b0139d&scoped=true"
import script from "./terms-of-use.vue?vue&type=script&lang=js"
export * from "./terms-of-use.vue?vue&type=script&lang=js"

import "./terms-of-use.vue?vue&type=style&index=0&id=68b0139d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68b0139d"]])

export default __exports__